import { Divider, Stack, type Theme, Typography, styled } from "@mui/material"
import { formatPercentage } from "@pharmupp/p3-front-commons"

export const Title = styled(Typography)({
  fontWeight: "600",
  textTransform: "uppercase",
})

export const TitleSuffix = styled(Title)(({ theme }) => ({
  color: theme.palette.info.dark,
}))

export const Row = styled(Stack)({
  flexDirection: "row",
})

export const VerticalSeparator = styled(Divider)({})
VerticalSeparator.defaultProps = {
  flexItem: true,
  orientation: "vertical",
}

export const BarSegment = styled(Row)({
  height: 14,
})
export const BarTrack = styled(BarSegment)(({ theme }) => ({
  borderRadius: theme.spacing(0.5),
  gap: theme.spacing(0.5),
  backgroundColor: theme.palette.common.white,
  overflow: "hidden",
  minWidth: "100%",
}))

const ShareBase = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.darkBlue,
}))

const SmallShare = styled(ShareBase)({
  fontWeight: 500,
})
SmallShare.defaultProps = {
  variant: "14px",
}

const BigShare = styled(ShareBase)({
  fontWeight: 600,
})
BigShare.defaultProps = {
  variant: "20px",
}

export interface ShareProps {
  value: number | null
  variant?: "small" | "big"
  color?: string | ((theme: Theme) => string)
}

export const Share = ({ value, variant = "small", color }: ShareProps) => {
  const share = formatPercentage(value, {
    maximumFractionDigits: 1,
    minimumFractionDigits: 1,
    trailingZeroDisplay: "stripIfInteger",
  })
  const ShareCmp = variant === "small" ? SmallShare : BigShare
  return <ShareCmp sx={{ color }}>{share}</ShareCmp>
}
